import React from 'react';
import { ResumeAdditionalEdit, ResumeAdditionalEditProps, coreResumeApi } from '@cp/entities/resume';
import { useApiServerErrorHandler } from 'src/shared/apiServer';
import { ResumeEditAdditionalProps } from './model';

export const ResumeEditAdditional: React.FC<ResumeEditAdditionalProps> = ({ data, onComplete }) => {
  const handleApiServerError = useApiServerErrorHandler();
  const [update] = coreResumeApi.endpoints.updateForCurrentClientById.useMutation();

  const handleSubmit: ResumeAdditionalEditProps['onSubmit'] = async (values, { form }) => {
    const response = await update({ body: values, params: { id: data.id } });

    if ('error' in response) {
      handleApiServerError(response.error, { form });
    } else {
      onComplete?.();
    }
  };

  return <ResumeAdditionalEdit data={data} onSubmit={handleSubmit} />;
};
